// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed494940","590":"0deba205","667":"f2206958","692":"d7cee561"}[chunkId] + ".chunk.js";
};